import React from 'react';
import './Toggle.css';

/**
 * Toggle Component (Switch)
 *
 * @param {boolean} checked - Toggle state
 * @param {function} onChange - Change handler
 * @param {string} size - 'sm' | 'md' | 'lg'
 * @param {string} label - Label text
 * @param {string} description - Description text
 * @param {boolean} disabled - Disable toggle
 */
const Toggle = ({
  checked = false,
  onChange,
  size = 'md',
  label,
  description,
  disabled = false,
  className = '',
  id,
  ...props
}) => {
  const toggleId = id || `toggle-${Math.random().toString(36).substr(2, 9)}`;

  const containerClassNames = [
    'oz-toggle-container',
    className
  ].filter(Boolean).join(' ');

  const toggleClassNames = [
    'oz-toggle',
    `oz-toggle--${size}`,
    checked && 'oz-toggle--checked',
    disabled && 'oz-toggle--disabled',
  ].filter(Boolean).join(' ');

  const handleChange = (e) => {
    if (!disabled && onChange) {
      onChange(e.target.checked);
    }
  };

  return (
    <div className={containerClassNames}>
      <label className="oz-toggle-wrapper" htmlFor={toggleId}>
        <input
          type="checkbox"
          id={toggleId}
          className="oz-toggle-input"
          checked={checked}
          onChange={handleChange}
          disabled={disabled}
          {...props}
        />
        <span className={toggleClassNames}>
          <span className="oz-toggle-thumb" />
        </span>
        {(label || description) && (
          <div className="oz-toggle-content">
            {label && <span className="oz-toggle-label">{label}</span>}
            {description && <span className="oz-toggle-description">{description}</span>}
          </div>
        )}
      </label>
    </div>
  );
};

export default Toggle;
